import { apiClient } from "@/api/client";
import { Team, TeamsRespose } from "@/pages/teams/store/teamsStore";
import useAuthStore from "@/store/authStore";
import useGlobalStore from "@/store/globalStore";
import { AxiosError } from "axios";
import { create } from "zustand";

export interface Person {
  id: string;
  user_id: string;
  email: string;
  status: string;
  expires_at: string;
  created_at: string;
  updated_at: string;
}

export interface SendInvitationData {
  FirstName: string;
  LastName: string;
  email: string;
  message?: string;
}

export interface SendMediaUserInvitationData {
  email: string;
  firstName: string;
  lastName: string;
  team_id: string;
  role: string;
  role_id: string;
  role_type: string;
  media_agency_id: string;
}

interface ManagePeopleState {
  people: Person[];
  teams: Team[];
  sendMediaAdminInvitation: (data: SendInvitationData) => Promise<void>;
  sendMediaUserInvitation: (data: SendMediaUserInvitationData) => Promise<void>;
  fetchPeople: () => Promise<void>;
  getTeams: () => Promise<void>;
}

const useManagePeopleStore = create<ManagePeopleState>((set) => ({
  people: [],
  teams: [],

  sendMediaAdminInvitation: async (data) => {
    try {
      const response = await apiClient.post(
        "/global-media-agency-invitations",
        data
      );
      set((state) => ({
        people: [...state.people, response.data.invite],
      }));
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage =
        axiosError.response?.data?.error || "Failed to send invitation.";
      throw new Error(errorMessage);
    }
  },

  sendMediaUserInvitation: async (data) => {
    try {
      const response = await apiClient.post("/media-agency-invitations", data);
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage =
        axiosError.response?.data?.error || "Failed to send invitation.";
      throw new Error(errorMessage);
    }
  },

  fetchPeople: async () => {
    try {
      const user_role = useAuthStore.getState().user_role;
      const response = await apiClient.get(
        user_role === "Global Admin"
          ? "/global-media-agency-invitations"
          : "/media-agency-invitations"
      );
      set({ people: response.data.data });
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage =
        axiosError.response?.data?.error || "Failed to fetch people.";
      throw new Error(errorMessage);
    }
  },

  getTeams: async () => {
    try {
      const response = await apiClient.get<TeamsRespose>("/teams");
      const data = response.data;
      console.log(data.teams);
      set({ teams: data.teams });
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage = axiosError.response
        ? axiosError.response.data?.error || "Something went wrong"
        : "Something went wrong";
      throw new Error(errorMessage);
    }
  },
}));

export default useManagePeopleStore;
